module.exports = __webpack_public_path__ + "img/icon-runner.7ddb6c13.svg";